// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ICreateExcessContributionFormDto,
  ICreateExcessContributionFormResponseDto,
  ICustomPagePublicStatementInfoDto,
  ICustomPageTaxFormInfoDto,
  IErrorDto,
  IExcessContributionFileResponseDto,
  IExcessContributionFormResponseDto,
  IGenericErrorDto,
  ITaxFormMailingCreateDto,
  ITaxFormMailingHistoryDto,
} from '../models/index';
import {
    ICreateExcessContributionFormDtoFromJSON,
    ICreateExcessContributionFormDtoToJSON,
    ICreateExcessContributionFormResponseDtoFromJSON,
    ICreateExcessContributionFormResponseDtoToJSON,
    ICustomPagePublicStatementInfoDtoFromJSON,
    ICustomPagePublicStatementInfoDtoToJSON,
    ICustomPageTaxFormInfoDtoFromJSON,
    ICustomPageTaxFormInfoDtoToJSON,
    IErrorDtoFromJSON,
    IErrorDtoToJSON,
    IExcessContributionFileResponseDtoFromJSON,
    IExcessContributionFileResponseDtoToJSON,
    IExcessContributionFormResponseDtoFromJSON,
    IExcessContributionFormResponseDtoToJSON,
    IGenericErrorDtoFromJSON,
    IGenericErrorDtoToJSON,
    ITaxFormMailingCreateDtoFromJSON,
    ITaxFormMailingCreateDtoToJSON,
    ITaxFormMailingHistoryDtoFromJSON,
    ITaxFormMailingHistoryDtoToJSON,
} from '../models/index';

export interface CreateExcessContributionRequest {
    iCreateExcessContributionFormDto: ICreateExcessContributionFormDto;
}

export interface CreateMailingRecordRequest {
    iTaxFormMailingCreateDto: ITaxFormMailingCreateDto;
}

export interface DownloadTaxForm1099PdfRequest {
    id: number;
}

export interface DownloadTaxForm5498PdfRequest {
    id: number;
}

export interface GetExcessContributionByIdRequest {
    id: number;
}

export interface GetStatementsRequest {
    accountId?: number;
    employeeId?: number;
    name?: string;
    statementYears?: Set<number>;
    types?: Set<GetStatementsTypesEnum>;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetTaxFormsInfoRequest {
    employeeId?: number;
    taxYears?: Set<string>;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetTaxFormsInfo1Request {
    employeeId?: number;
    taxYears?: Set<string>;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface UploadExcessContributionFileRequest {
    employeeId: number;
    file: Blob;
}

/**
 * StatementServiceServiceApi - interface
 * 
 * @export
 * @interface StatementServiceServiceApiInterface
 */
export interface StatementServiceServiceApiInterface {
    /**
     * 
     * @summary Create excess contribution
     * @param {ICreateExcessContributionFormDto} iCreateExcessContributionFormDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatementServiceServiceApiInterface
     */
    createExcessContributionRaw(requestParameters: CreateExcessContributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICreateExcessContributionFormResponseDto>>;

    /**
     * Create excess contribution
     */
    createExcessContribution(requestParameters: CreateExcessContributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICreateExcessContributionFormResponseDto>;

    /**
     * 
     * @summary Trigger physical mailing of a tax form
     * @param {ITaxFormMailingCreateDto} iTaxFormMailingCreateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatementServiceServiceApiInterface
     */
    createMailingRecordRaw(requestParameters: CreateMailingRecordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ITaxFormMailingHistoryDto>>;

    /**
     * Trigger physical mailing of a tax form
     */
    createMailingRecord(requestParameters: CreateMailingRecordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ITaxFormMailingHistoryDto>;

    /**
     * 
     * @summary Disable tax form banner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatementServiceServiceApiInterface
     */
    disableTaxFormBannerRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Disable tax form banner
     */
    disableTaxFormBanner(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Download Tax Form 1099 as PDF
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatementServiceServiceApiInterface
     */
    downloadTaxForm1099PdfRaw(requestParameters: DownloadTaxForm1099PdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Download Tax Form 1099 as PDF
     */
    downloadTaxForm1099Pdf(requestParameters: DownloadTaxForm1099PdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Download Tax Form 5498 as PDF
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatementServiceServiceApiInterface
     */
    downloadTaxForm5498PdfRaw(requestParameters: DownloadTaxForm5498PdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Download Tax Form 5498 as PDF
     */
    downloadTaxForm5498Pdf(requestParameters: DownloadTaxForm5498PdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get excess contribution by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatementServiceServiceApiInterface
     */
    getExcessContributionByIdRaw(requestParameters: GetExcessContributionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IExcessContributionFormResponseDto>>;

    /**
     * Get excess contribution by id
     */
    getExcessContributionById(requestParameters: GetExcessContributionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IExcessContributionFormResponseDto>;

    /**
     * 
     * @summary Get statements info
     * @param {number} [accountId] 
     * @param {number} [employeeId] 
     * @param {string} [name] 
     * @param {Set<number>} [statementYears] 
     * @param {Set<'BANKING_STATEMENT' | 'INVESTMENT_STATEMENT'>} [types] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatementServiceServiceApiInterface
     */
    getStatementsRaw(requestParameters: GetStatementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPagePublicStatementInfoDto>>;

    /**
     * Get statements info
     */
    getStatements(requestParameters: GetStatementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPagePublicStatementInfoDto>;

    /**
     * 
     * @summary Get tax form banner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatementServiceServiceApiInterface
     */
    getTaxFormBannerRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Get tax form banner
     */
    getTaxFormBanner(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * **RECOMMENDED:** This is the current version of the tax forms endpoint. It includes all tax form types including excess contributions (TAX_FORM_EXCESS_1099). Use this endpoint for new integrations.
     * @summary Get Tax Forms V2 (Recommended)
     * @param {number} [employeeId] 
     * @param {Set<string>} [taxYears] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatementServiceServiceApiInterface
     */
    getTaxFormsInfoRaw(requestParameters: GetTaxFormsInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageTaxFormInfoDto>>;

    /**
     * **RECOMMENDED:** This is the current version of the tax forms endpoint. It includes all tax form types including excess contributions (TAX_FORM_EXCESS_1099). Use this endpoint for new integrations.
     * Get Tax Forms V2 (Recommended)
     */
    getTaxFormsInfo(requestParameters: GetTaxFormsInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageTaxFormInfoDto>;

    /**
     * **DEPRECATED:** This endpoint is kept for backward compatibility with mobile apps. New integrations should use `/v2/tax-forms` which includes excess contributions.
     * @summary Get Tax Forms
     * @param {number} [employeeId] 
     * @param {Set<string>} [taxYears] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof StatementServiceServiceApiInterface
     */
    getTaxFormsInfo1Raw(requestParameters: GetTaxFormsInfo1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageTaxFormInfoDto>>;

    /**
     * **DEPRECATED:** This endpoint is kept for backward compatibility with mobile apps. New integrations should use `/v2/tax-forms` which includes excess contributions.
     * Get Tax Forms
     * @deprecated
     */
    getTaxFormsInfo1(requestParameters: GetTaxFormsInfo1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageTaxFormInfoDto>;

    /**
     * 
     * @summary Upload excess contributions file
     * @param {number} employeeId 
     * @param {Blob} file File to upload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatementServiceServiceApiInterface
     */
    uploadExcessContributionFileRaw(requestParameters: UploadExcessContributionFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IExcessContributionFileResponseDto>>;

    /**
     * Upload excess contributions file
     */
    uploadExcessContributionFile(requestParameters: UploadExcessContributionFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IExcessContributionFileResponseDto>;

}

/**
 * 
 */
export class StatementServiceServiceApi extends runtime.BaseAPI implements StatementServiceServiceApiInterface {

    /**
     * Create excess contribution
     */
    async createExcessContributionRaw(requestParameters: CreateExcessContributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICreateExcessContributionFormResponseDto>> {
        if (requestParameters['iCreateExcessContributionFormDto'] == null) {
            throw new runtime.RequiredError(
                'iCreateExcessContributionFormDto',
                'Required parameter "iCreateExcessContributionFormDto" was null or undefined when calling createExcessContribution().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tax-forms/excess-contributions`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ICreateExcessContributionFormDtoToJSON(requestParameters['iCreateExcessContributionFormDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICreateExcessContributionFormResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create excess contribution
     */
    async createExcessContribution(requestParameters: CreateExcessContributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICreateExcessContributionFormResponseDto> {
        const response = await this.createExcessContributionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Trigger physical mailing of a tax form
     */
    async createMailingRecordRaw(requestParameters: CreateMailingRecordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ITaxFormMailingHistoryDto>> {
        if (requestParameters['iTaxFormMailingCreateDto'] == null) {
            throw new runtime.RequiredError(
                'iTaxFormMailingCreateDto',
                'Required parameter "iTaxFormMailingCreateDto" was null or undefined when calling createMailingRecord().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tax-forms/mailing-history`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ITaxFormMailingCreateDtoToJSON(requestParameters['iTaxFormMailingCreateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ITaxFormMailingHistoryDtoFromJSON(jsonValue));
    }

    /**
     * Trigger physical mailing of a tax form
     */
    async createMailingRecord(requestParameters: CreateMailingRecordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ITaxFormMailingHistoryDto> {
        const response = await this.createMailingRecordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Disable tax form banner
     */
    async disableTaxFormBannerRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tax-forms/tax-form-banner/disable`;

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Disable tax form banner
     */
    async disableTaxFormBanner(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.disableTaxFormBannerRaw(initOverrides);
    }

    /**
     * Download Tax Form 1099 as PDF
     */
    async downloadTaxForm1099PdfRaw(requestParameters: DownloadTaxForm1099PdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling downloadTaxForm1099Pdf().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tax-forms/tax-form-1099/{id}/download`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Download Tax Form 1099 as PDF
     */
    async downloadTaxForm1099Pdf(requestParameters: DownloadTaxForm1099PdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.downloadTaxForm1099PdfRaw(requestParameters, initOverrides);
    }

    /**
     * Download Tax Form 5498 as PDF
     */
    async downloadTaxForm5498PdfRaw(requestParameters: DownloadTaxForm5498PdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling downloadTaxForm5498Pdf().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tax-forms/tax-form-5498/{id}/download`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Download Tax Form 5498 as PDF
     */
    async downloadTaxForm5498Pdf(requestParameters: DownloadTaxForm5498PdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.downloadTaxForm5498PdfRaw(requestParameters, initOverrides);
    }

    /**
     * Get excess contribution by id
     */
    async getExcessContributionByIdRaw(requestParameters: GetExcessContributionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IExcessContributionFormResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getExcessContributionById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tax-forms/excess-contributions/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IExcessContributionFormResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get excess contribution by id
     */
    async getExcessContributionById(requestParameters: GetExcessContributionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IExcessContributionFormResponseDto> {
        const response = await this.getExcessContributionByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get statements info
     */
    async getStatementsRaw(requestParameters: GetStatementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPagePublicStatementInfoDto>> {
        const queryParameters: any = {};

        if (requestParameters['accountId'] != null) {
            queryParameters['account_id'] = requestParameters['accountId'];
        }

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['statementYears'] != null) {
            queryParameters['statement_years'] = requestParameters['statementYears'];
        }

        if (requestParameters['types'] != null) {
            queryParameters['types'] = requestParameters['types'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/statements`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICustomPagePublicStatementInfoDtoFromJSON(jsonValue));
    }

    /**
     * Get statements info
     */
    async getStatements(requestParameters: GetStatementsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPagePublicStatementInfoDto> {
        const response = await this.getStatementsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get tax form banner
     */
    async getTaxFormBannerRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tax-forms/tax-form-banner`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get tax form banner
     */
    async getTaxFormBanner(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getTaxFormBannerRaw(initOverrides);
    }

    /**
     * **RECOMMENDED:** This is the current version of the tax forms endpoint. It includes all tax form types including excess contributions (TAX_FORM_EXCESS_1099). Use this endpoint for new integrations.
     * Get Tax Forms V2 (Recommended)
     */
    async getTaxFormsInfoRaw(requestParameters: GetTaxFormsInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageTaxFormInfoDto>> {
        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['taxYears'] != null) {
            queryParameters['tax_years'] = requestParameters['taxYears'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v2/tax-forms`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICustomPageTaxFormInfoDtoFromJSON(jsonValue));
    }

    /**
     * **RECOMMENDED:** This is the current version of the tax forms endpoint. It includes all tax form types including excess contributions (TAX_FORM_EXCESS_1099). Use this endpoint for new integrations.
     * Get Tax Forms V2 (Recommended)
     */
    async getTaxFormsInfo(requestParameters: GetTaxFormsInfoRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageTaxFormInfoDto> {
        const response = await this.getTaxFormsInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * **DEPRECATED:** This endpoint is kept for backward compatibility with mobile apps. New integrations should use `/v2/tax-forms` which includes excess contributions.
     * Get Tax Forms
     * @deprecated
     */
    async getTaxFormsInfo1Raw(requestParameters: GetTaxFormsInfo1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageTaxFormInfoDto>> {
        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['taxYears'] != null) {
            queryParameters['tax_years'] = requestParameters['taxYears'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tax-forms`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICustomPageTaxFormInfoDtoFromJSON(jsonValue));
    }

    /**
     * **DEPRECATED:** This endpoint is kept for backward compatibility with mobile apps. New integrations should use `/v2/tax-forms` which includes excess contributions.
     * Get Tax Forms
     * @deprecated
     */
    async getTaxFormsInfo1(requestParameters: GetTaxFormsInfo1Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageTaxFormInfoDto> {
        const response = await this.getTaxFormsInfo1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload excess contributions file
     */
    async uploadExcessContributionFileRaw(requestParameters: UploadExcessContributionFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IExcessContributionFileResponseDto>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling uploadExcessContributionFile().'
            );
        }

        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling uploadExcessContributionFile().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee-id'] = requestParameters['employeeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }


        let urlPath = `/tax-forms/excess-contributions/file-upload`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IExcessContributionFileResponseDtoFromJSON(jsonValue));
    }

    /**
     * Upload excess contributions file
     */
    async uploadExcessContributionFile(requestParameters: UploadExcessContributionFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IExcessContributionFileResponseDto> {
        const response = await this.uploadExcessContributionFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
  * @export
  * @enum {string}
  */
export enum GetStatementsTypesEnum {
    BANKING_STATEMENT = 'BANKING_STATEMENT',
    INVESTMENT_STATEMENT = 'INVESTMENT_STATEMENT'
}
